var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaperclip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4995 6.24951L5.99112 12.866C5.7567 13.1004 5.625 13.4184 5.625 13.7499C5.625 14.0814 5.7567 14.3994 5.99112 14.6338C6.22554 14.8682 6.54348 14.9999 6.875 14.9999C7.20652 14.9999 7.52446 14.8682 7.75888 14.6338L15.5173 6.76728C15.7495 6.53513 15.9336 6.25953 16.0592 5.95622C16.1849 5.65291 16.2495 5.32782 16.2495 4.99951C16.2495 4.67121 16.1849 4.34612 16.0592 4.0428C15.9336 3.73949 15.7495 3.46389 15.5173 3.23174C15.2852 2.9996 15.0096 2.81545 14.7063 2.68981C14.4029 2.56418 14.0778 2.49951 13.7495 2.49951C13.4212 2.49951 13.0961 2.56418 12.7928 2.68981C12.4895 2.81545 12.2139 2.9996 11.9818 3.23174L4.22335 11.0982C3.52009 11.8015 3.125 12.7553 3.125 13.7499C3.125 14.7445 3.52009 15.6983 4.22335 16.4015C4.92661 17.1048 5.88044 17.4999 6.875 17.4999C7.86956 17.4999 8.82339 17.1048 9.52665 16.4015L15.937 9.99951",
    stroke: "#007FA1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip);
export default __webpack_public_path__ + "static/media/paperclip.aa381ce0da8a7c8d632c56dbd14d5560.svg";
export { ForwardRef as ReactComponent };